import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

export default function MeetRomii() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="romii" ref={ref} className="py-24 lg:py-32" data-testid="romii-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow number="02" label="Featured Product" />
              <div className="flex items-center gap-4 mb-6">
                <img src="/assets/romii-icon.png" alt="Romii" className="h-14 w-14" data-testid="romii-logo" />
                <p className="text-xs tracking-[0.2em] uppercase text-gray-400 font-semibold">
                  by Huminence Technologies Inc.
                </p>
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827]">
                Meet <span className="text-[#E89A4D] font-medium">Romii</span>
              </h2>
              <p className="mt-3 text-base md:text-lg text-gray-500 font-medium">
                An AI Companion for Cognitive Care.
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-8 space-y-5 text-gray-500 leading-relaxed text-base md:text-lg max-w-xl">
                <p>
                  Romii is an intelligent wearable companion designed for individuals living with
                  Alzheimer's disease, dementia, and other forms of cognitive decline.
                </p>
                <p>
                  Rather than focusing only on emergencies, Romii is designed around everyday life.
                  It helps people remain confident, connected, reassured, and as independent as
                  possible — while giving caregivers greater peace of mind.
                </p>
                <p className="text-[#111827]">
                  The goal is not to replace human care.{" "}
                  <span className="font-serif-italic text-[1.1em]">The goal is to strengthen it.</span>
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.15}>
              <motion.div style={{ y }} className="relative">
                <div className="rounded-[2rem] bg-[#F9FAFB] p-6 lg:p-8 card-soft">
                  <img
                    src="/assets/romii-float.jpg"
                    alt="Romii wearable companion concept render"
                    className="w-full rounded-2xl object-cover"
                    data-testid="romii-product-image"
                  />
                  <div className="mt-4 grid grid-cols-2 gap-4">
                    <img
                      src="/assets/romii-neck.jpg"
                      alt="Romii worn around the neck"
                      className="rounded-xl object-cover aspect-[4/3] hover:scale-[1.02] transition-transform duration-500"
                      data-testid="romii-neck-image"
                    />
                    <img
                      src="/assets/romii-wrist.jpg"
                      alt="Romii worn on the wrist"
                      className="rounded-xl object-cover aspect-[4/3] hover:scale-[1.02] transition-transform duration-500"
                      data-testid="romii-wrist-image"
                    />
                  </div>
                  <p className="mt-5 text-center text-[11px] tracking-[0.18em] uppercase text-gray-400 font-semibold">
                    Concept Illustration • Final production design may vary.
                  </p>
                </div>
                <div className="absolute -top-5 -right-5 h-16 w-16 rounded-2xl bg-white card-soft flex items-center justify-center">
                  <img src="/assets/romii-icon.png" alt="" className="h-9 w-9" />
                </div>
              </motion.div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
